if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton && this.submitButton.querySelector('span') || null;

        /* Alex Add */
        this.cardOption = this.form.querySelectorAll('.product-card-option');
        this.cardOption.length>0 && this.cardOption.forEach(e => {
          e.addEventListener('click',this.onChangeOption.bind(this))
        });

        if (document.querySelector('cart-drawer')&&this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog'); 

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        this.submitButton.closest('.drawer.active') && this.submitButton.closest('.drawer.active').classList.remove('active');//close modal before add product
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id') ||  formData.get('items[][id]'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id') ||  formData.get('items[][id]'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      getImgSrcset(t){
        var s = [165,360,533,720,940,1000],r = [];
        s.forEach(e=>{
          var d = t + '&width=' + e + ' ' + e + 'w';
          r.push(d);
        });
        return r.join(',');
      }

      onChangeOption(e){
        const t = e.currentTarget,
        di = t.dataset.src,
        id = t.dataset.id,
        av = t.dataset.available,
        price = t.dataset.price,
        sprice = t.dataset.sprice,
        plc = t.dataset.plc,
        stock_qty = parseInt(t.dataset.qty),
        diy = t.dataset.diy,
        cp = t.closest('.card__pr_parent'),
        op_p = t.closest('.product-card-options'),
        tt = parseInt(op_p.dataset.total),
        cp_id = this.form.querySelector('input[name="id"]'),
        cp_img = cp.querySelector('.card__media img:first-child'),
        cdi = this.getImgSrcset(di);
        cp.querySelector('.product-card-option.active').classList.remove('active');
        t.classList.add('active');
        cp_img.setAttribute('srcset',cdi);
        cp_img.setAttribute('src',di);
        cp_id.setAttribute('value',id);
        //JS only available for one option trigger
        if(tt==1){
          //price
          if(price==sprice){
            cp.querySelector('.price').classList.remove('price--on-sale');
            const cp_price = cp.querySelector('.price__regular'),
            cpp = cp_price.querySelector('.price-item.price-item--regular');
            cpp.innerHTML = wsp.formatMoney(price);
          }else{
            cp.querySelector('.price').classList.add('price--on-sale');
            const cp_price = cp.querySelector('.price__sale'),
            cpp = cp_price.querySelector('.price-item.price-item--regular'),
            cpsp = cp_price.querySelector('.price-item.price-item--sale');
            cpp.innerHTML = wsp.formatMoney(price);
            cpsp.innerHTML = wsp.formatMoney(sprice);
          }
          //avaialble
          if(this.submitButton){
            if(av=='true'){
              this.submitButton.removeAttribute('disabled');
              if(stock_qty<=0 && plc=='continue'){
                this.submitButton.querySelectorAll('span').forEach(b=>{
                  b.innerHTML = wsp.preorderTxt;
                })
              }else{
                this.submitButton.querySelectorAll('span').forEach(b=>{
                  b.innerHTML = wsp.addBtnTxt;
                })
              }
            }else{
              this.submitButton.setAttribute('disabled','disabled');
              this.submitButton.querySelectorAll('span').forEach(b=>{
                b.innerHTML = wsp.soldBtnTxt;
              })
            }
          }
          /* other property */
          if(plc=='continue'||av=='false'|| diy=='true'){
            cp.querySelector('.card_estimated_time').classList.add('dn');
          }else{
            cp.querySelector('.card_estimated_time').classList.remove('dn');
          } 
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text, preorder) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          //preorder
          if(preorder){
            this.submitButtonText.textContent = window.variantStrings.preOrder;
          }else{
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]')||this.form.querySelector('[name="items[][id]"]');
      }
    }
  );
}
